export const EmailTemplates = {
  REVIEW_SOLICITATION: "review_solicitation",
  REVIEW_SOLICITATION_REMINDER: "review_solicitation_reminder",
  INFLUENCER: "influencer",
  FORM_SUBMISSION: "form_submission",
  REVIEW_REPLY: "review_reply"
};
